[
  {
    "drawBorder": true,
    "delayHorizontal": true,
    "horizontal": [
      {
        "name": "PrimaryTop",
        "startPosition": 5.6,
        "drawToPosition": 100,
        "drawFull": true,
        "drawFromPosition": 0
      },
      {
        "drawFromPosition": 0,
        "drawFull": true,
        "drawToPosition": 50,
        "startPosition": 50,
        "delay": 100,
        "name": "Equator"
      },
      {
        "drawToPosition": 100,
        "name": "PrimaryBottom",
        "drawFull": true,
        "delay": 200,
        "drawFromPosition": 0,
        "startPosition": 94.4
      },
      {
        "delay": 100,
        "startPosition": 50,
        "drawFull": true,
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "name": "EquatorRight"
      }
    ],
    "circle": [],
    "name": "ChapterSetup",
    "verticalDelayDirection": -1,
    "id": 0,
    "delayVertical": true,
    "mask": [],
    "duration": "1000",
    "vertical": [
      {
        "drawFull": true,
        "drawToPosition": 0,
        "drawFromPosition": 100,
        "startPosition": 3.1,
        "name": "PrimaryLeft"
      },
      {
        "drawFromPosition": 0,
        "drawToPosition": 50,
        "startPosition": 26,
        "drawFull": true,
        "name": "Left1"
      },
      {
        "drawToPosition": 50,
        "drawFromPosition": 0,
        "drawFull": true,
        "name": "Equator",
        "startPosition": 50
      },
      {
        "drawFull": true,
        "startPosition": 74,
        "drawToPosition": 50,
        "name": "Right1",
        "drawFromPosition": 0
      },
      {
        "drawFromPosition": 100,
        "drawToPosition": 0,
        "drawFull": true,
        "startPosition": 96.9,
        "name": "PrimaryRight"
      },
      {
        "name": "EquatorBottom",
        "drawFromPosition": 50,
        "drawFull": true,
        "startPosition": 50,
        "drawToPosition": 100
      },
      {
        "startPosition": 26,
        "drawToPosition": 100,
        "drawFull": true,
        "name": "Left1Bottom",
        "drawFromPosition": 50
      },
      {
        "drawFromPosition": 50,
        "name": "RightBottom",
        "drawToPosition": 100,
        "drawFull": true,
        "startPosition": 74
      }
    ]
  },
  {
    "delayVertical": false,
    "id": 0,
    "drawBorder": true,
    "horizontal": [
      {
        "drawToPosition": 100,
        "name": "PrimaryTop",
        "startPosition": 5.6,
        "drawFromPosition": 0,
        "drawFull": true
      },
      {
        "drawDirection": 1,
        "endPosition": 94.4,
        "drawFromPosition": 0,
        "drawFull": true,
        "name": "Equator",
        "startPosition": 50,
        "drawToPosition": 50
      },
      {
        "name": "PrimaryBottom",
        "startPosition": 94.4,
        "drawFull": true,
        "delay": 200,
        "drawFromPosition": 0,
        "drawToPosition": 100
      },
      {
        "startPosition": 50,
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "name": "EquatorRight",
        "delay": 100,
        "drawFull": true
      },
      {
        "drawFull": true,
        "endPosition": 27.5,
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "startPosition": 50,
        "name": "RightTopAux"
      }
    ],
    "duration": "1000",
    "vertical": [
      {
        "drawFromPosition": 100,
        "drawToPosition": 0,
        "startPosition": 3.1,
        "endPosition": -1,
        "drawFull": true,
        "name": "PrimaryLeft"
      },
      {
        "endPosition": -1,
        "name": "Left1",
        "drawFull": true,
        "startPosition": 26,
        "drawFromPosition": 0,
        "drawToPosition": 50
      },
      {
        "startPosition": 50,
        "drawToPosition": 50,
        "drawFull": true,
        "drawFromPosition": 0,
        "name": "Equator"
      },
      {
        "startPosition": 74,
        "drawFull": true,
        "drawToPosition": 50,
        "name": "Right1",
        "drawFromPosition": 0,
        "endPosition": 75
      },
      {
        "drawFromPosition": 100,
        "drawToPosition": 0,
        "name": "PrimaryRight",
        "startPosition": 96.9,
        "drawFull": true,
        "endPosition": 101
      },
      {
        "drawFromPosition": 50,
        "name": "EquatorBottom",
        "drawToPosition": 100,
        "drawFull": true,
        "startPosition": 50
      },
      {
        "startPosition": 26,
        "drawFull": true,
        "drawFromPosition": 50,
        "name": "Left1Bottom",
        "endPosition": -1,
        "drawToPosition": 100
      },
      {
        "drawToPosition": 100,
        "startPosition": 74,
        "endPosition": 75,
        "drawFromPosition": 50,
        "name": "RightBottom",
        "drawFull": true
      },
      {
        "drawToLine": "RightTopAux",
        "drawFull": true,
        "name": "AuxRight",
        "endPosition": 87.5,
        "startPosition": 101,
        "drawFromLine": "EquatorRight",
        "delay": 1000
      }
    ],
    "name": "ChapterEntry",
    "circle": [],
    "delayHorizontal": false,
    "mask": [
      {
        "polyOnly": true,
        "horizontal": [
          "RightTopAux",
          "EquatorRight"
        ],
        "vertical": [
          "Equator",
          "AuxRight"
        ],
        "asset": 0,
        "grid": 0,
        "name": "Heading"
      }
    ]
  },
  {
    "horizontal": [
      {
        "drawFull": true,
        "startPosition": 5.6,
        "drawFromPosition": 0,
        "endPosition": 5.6,
        "drawToPosition": 100,
        "name": "PrimaryTop"
      },
      {
        "endPosition": 94.4,
        "drawDirection": 1,
        "drawToPosition": 50,
        "drawFull": true,
        "startPosition": 94.4,
        "name": "Equator",
        "drawFromPosition": 0
      },
      {
        "drawFromPosition": 0,
        "endPosition": 94.4,
        "delay": 200,
        "drawToPosition": 100,
        "startPosition": 94.4,
        "name": "PrimaryBottom",
        "drawFull": true
      },
      {
        "drawToPosition": 100,
        "delay": 100,
        "startPosition": 50,
        "drawFull": true,
        "name": "EquatorRight",
        "endPosition": 50,
        "drawFromPosition": 50
      },
      {
        "drawToPosition": 100,
        "startPosition": 27.5,
        "drawFromPosition": 50,
        "endPosition": 27.5,
        "name": "RightTopAux",
        "drawFull": true
      }
    ],
    "mask": [
      {
        "name": "Hero",
        "horizontal": [
          "PrimaryTop",
          "PrimaryBottom"
        ],
        "coverFill": true,
        "grid": 0,
        "asset": 0,
        "vertical": [
          "Left Border",
          "HeroMaskLine"
        ],
        "container": "mask"
      },
      {
        "container": "mask",
        "horizontal": [
          "EquatorRight",
          "PrimaryBottom"
        ],
        "name": "Grid1",
        "grid": 0,
        "vertical": [
          "RightBottom",
          "Grid1MaskLine"
        ],
        "coverFill": true,
        "asset": 1
      },
      {
        "coverFill": true,
        "name": "Grid2",
        "asset": 2,
        "horizontal": [
          "PrimaryTop",
          "RightTopAux"
        ],
        "container": "mask",
        "grid": 0,
        "vertical": [
          "Right1",
          "Grid2MaskLine"
        ]
      },
      {
        "grid": 0,
        "name": "Heading",
        "asset": 0,
        "vertical": [
          "Equator",
          "AuxRight"
        ],
        "horizontal": [
          "RightTopAux",
          "EquatorRight"
        ],
        "polyOnly": true
      }
    ],
    "id": 0,
    "duration": "1000",
    "drawBorder": true,
    "delayVertical": false,
    "circle": [],
    "delayHorizontal": false,
    "vertical": [
      {
        "drawFull": true,
        "drawFromPosition": 100,
        "drawToPosition": 0,
        "endPosition": -1,
        "startPosition": -1,
        "name": "PrimaryLeft"
      },
      {
        "drawFull": true,
        "endPosition": -1,
        "startPosition": -1,
        "drawFromPosition": 0,
        "name": "Left1",
        "drawToPosition": 50
      },
      {
        "name": "Equator",
        "startPosition": 50,
        "drawFull": true,
        "drawToPosition": 50,
        "endPosition": 50,
        "drawFromPosition": 0
      },
      {
        "drawFull": true,
        "startPosition": 75,
        "endPosition": 75,
        "drawFromPosition": 0,
        "name": "Right1",
        "drawToPosition": 50
      },
      {
        "drawFromPosition": 100,
        "drawFull": true,
        "name": "PrimaryRight",
        "drawToPosition": 0,
        "startPosition": 101,
        "endPosition": 101
      },
      {
        "drawToPosition": 100,
        "endPosition": 50,
        "drawFull": true,
        "drawFromPosition": 50,
        "startPosition": 50,
        "name": "EquatorBottom"
      },
      {
        "endPosition": -1,
        "startPosition": -1,
        "name": "Left1Bottom",
        "drawFull": true,
        "drawFromPosition": 50,
        "drawToPosition": 100
      },
      {
        "name": "RightBottom",
        "startPosition": 75,
        "drawFull": true,
        "endPosition": 75,
        "drawFromPosition": 50,
        "drawToPosition": 100
      },
      {
        "delay": 1000,
        "drawToLine": "RightTopAux",
        "name": "AuxRight",
        "drawFromLine": "EquatorRight",
        "endPosition": 87.5,
        "startPosition": 87.5,
        "drawFull": true
      },
      {
        "startPosition": 0,
        "drawFromPosition": 0,
        "drawFull": true,
        "endPosition": 50,
        "drawToPosition": 100,
        "name": "HeroMaskLine",
        "startAlpha": 0.01
      },
      {
        "startAlpha": 0.01,
        "drawFromPosition": 0,
        "drawFull": true,
        "name": "Grid1MaskLine",
        "startPosition": 75,
        "endPosition": 100,
        "drawToPosition": 100
      },
      {
        "name": "Grid2MaskLine",
        "startAlpha": 0.01,
        "startPosition": 75,
        "drawFull": true,
        "drawToPosition": 100,
        "endPosition": 100,
        "delay": 500,
        "drawFromPosition": 0
      }
    ],
    "name": "ChapterEntry"
  },
  {
    "delayVertical": false,
    "delayHorizontal": false,
    "vertical": [
      {
        "startPosition": -1,
        "drawFull": true,
        "endPosition": -1,
        "drawToPosition": 0,
        "name": "PrimaryLeft",
        "drawFromPosition": 100
      },
      {
        "startPosition": -1,
        "endPosition": -1,
        "drawFull": true,
        "drawToPosition": 50,
        "name": "Left1",
        "drawFromPosition": 0
      },
      {
        "drawFull": true,
        "drawFromPosition": 0,
        "name": "Equator",
        "startPosition": 50,
        "endPosition": 50,
        "drawToPosition": 50
      },
      {
        "drawFromPosition": 0,
        "drawFull": true,
        "drawToPosition": 50,
        "name": "Right1",
        "startPosition": 75,
        "endPosition": 75
      },
      {
        "endPosition": 101,
        "drawFromPosition": 100,
        "drawToPosition": 0,
        "startPosition": 101,
        "drawFull": true,
        "name": "PrimaryRight"
      },
      {
        "drawToPosition": 100,
        "startPosition": 50,
        "drawFromPosition": 50,
        "name": "EquatorBottom",
        "endPosition": 50,
        "drawFull": true
      },
      {
        "drawFull": true,
        "endPosition": -1,
        "name": "Left1Bottom",
        "drawToPosition": 100,
        "startPosition": -1,
        "drawFromPosition": 50
      },
      {
        "name": "RightBottom",
        "drawFull": true,
        "endPosition": 75,
        "drawToPosition": 100,
        "startPosition": 75,
        "drawFromPosition": 50
      },
      {
        "startPosition": 87.5,
        "name": "AuxRight",
        "endPosition": 87.5,
        "drawFromLine": "EquatorRight",
        "drawFull": true,
        "delay": 1000,
        "drawToLine": "RightTopAux"
      },
      {
        "drawFull": true,
        "name": "HeroMaskLine",
        "drawFromPosition": 0,
        "drawToPosition": 100,
        "delay": 3000,
        "endPosition": 0,
        "startAlpha": 0.01,
        "startPosition": 50
      },
      {
        "startAlpha": 0.01,
        "drawFull": true,
        "delay": 2500,
        "name": "Grid1MaskLine",
        "endPosition": 75,
        "drawToPosition": 100,
        "startPosition": 100,
        "drawFromPosition": 0
      },
      {
        "drawFull": true,
        "drawFromPosition": 0,
        "startPosition": 100,
        "drawToPosition": 100,
        "startAlpha": 0.01,
        "endPosition": 75,
        "delay": 1500,
        "name": "Grid2MaskLine"
      }
    ],
    "mask": [
      {
        "horizontal": [
          "PrimaryTop",
          "PrimaryBottom"
        ],
        "name": "Hero",
        "grid": 0,
        "coverFill": true,
        "vertical": [
          "Left Border",
          "HeroMaskLine"
        ],
        "asset": 0,
        "container": "mask"
      },
      {
        "name": "Grid1",
        "coverFill": true,
        "vertical": [
          "RightBottom",
          "Grid1MaskLine"
        ],
        "asset": 1,
        "grid": 0,
        "horizontal": [
          "EquatorRight",
          "PrimaryBottom"
        ],
        "container": "mask"
      },
      {
        "grid": 0,
        "asset": 2,
        "vertical": [
          "Right1",
          "Grid2MaskLine"
        ],
        "name": "Grid2",
        "horizontal": [
          "PrimaryTop",
          "RightTopAux"
        ],
        "container": "mask",
        "coverFill": true
      },
      {
        "vertical": [
          "Equator",
          "AuxRight"
        ],
        "asset": 0,
        "name": "Heading",
        "horizontal": [
          "RightTopAux",
          "EquatorRight"
        ],
        "polyOnly": true,
        "grid": 0
      }
    ],
    "drawBorder": true,
    "circle": [],
    "duration": "1000",
    "name": "ChapterEntry",
    "horizontal": [
      {
        "drawFromPosition": 0,
        "endPosition": 5.6,
        "drawToPosition": 100,
        "name": "PrimaryTop",
        "drawFull": true,
        "startPosition": 5.6
      },
      {
        "startPosition": 94.4,
        "drawFull": true,
        "drawToPosition": 50,
        "endPosition": 94.4,
        "drawDirection": 1,
        "name": "Equator",
        "drawFromPosition": 0
      },
      {
        "startPosition": 94.4,
        "drawFromPosition": 0,
        "delay": 200,
        "drawFull": true,
        "drawToPosition": 100,
        "endPosition": 94.4,
        "name": "PrimaryBottom"
      },
      {
        "endPosition": 50,
        "drawFull": true,
        "drawFromPosition": 50,
        "name": "EquatorRight",
        "startPosition": 50,
        "delay": 100,
        "drawToPosition": 100
      },
      {
        "drawToPosition": 100,
        "name": "RightTopAux",
        "drawFromPosition": 50,
        "drawFull": true,
        "endPosition": 27.5,
        "startPosition": 27.5
      }
    ],
    "id": 0
  },
  {
    "drawBorder": true,
    "mask": [],
    "id": 0,
    "name": "ChapterExit",
    "circle": [],
    "delayHorizontal": false,
    "vertical": [
      {
        "drawFull": true,
        "startPosition": -1,
        "delay": 1000,
        "drawFromPosition": 100,
        "name": "PrimaryLeft",
        "drawToPosition": 0,
        "endPosition": 3.1
      },
      {
        "drawFromPosition": 0,
        "drawToPosition": 50,
        "startPosition": -1,
        "drawFull": true,
        "name": "Left1",
        "endPosition": 26
      },
      {
        "drawFromPosition": 0,
        "name": "Equator",
        "startPosition": 50,
        "drawFull": true,
        "drawToPosition": 50
      },
      {
        "drawFull": true,
        "drawFromPosition": 0,
        "startPosition": 75,
        "name": "Right1",
        "drawToPosition": 50,
        "endPosition": 74
      },
      {
        "drawToPosition": 0,
        "delay": 1000,
        "drawFromPosition": 100,
        "name": "PrimaryRight",
        "startPosition": 101,
        "endPosition": 96.9,
        "drawFull": true
      },
      {
        "name": "EquatorBottom",
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "drawFull": true,
        "startPosition": 50
      },
      {
        "endPosition": 26,
        "drawFromPosition": 50,
        "drawFull": true,
        "drawToPosition": 100,
        "name": "Left1Bottom",
        "startPosition": -1
      },
      {
        "drawFromPosition": 50,
        "drawFull": true,
        "endPosition": 74,
        "startPosition": 75,
        "name": "RightBottom",
        "drawToPosition": 100
      },
      {
        "drawFromLine": "EquatorRight",
        "drawDirection": 1,
        "drawFull": false,
        "startPosition": 87.5,
        "endPosition": 101,
        "drawToLine": "RightTopAux",
        "name": "AuxRight",
        "extend": true
      }
    ],
    "duration": "1000",
    "horizontal": [
      {
        "drawToPosition": 100,
        "drawFull": true,
        "startPosition": 5.6,
        "name": "PrimaryTop",
        "drawFromPosition": 0
      },
      {
        "drawFull": true,
        "drawFromPosition": 0,
        "name": "Equator",
        "drawToPosition": 50,
        "startPosition": 94.4,
        "drawDirection": 1,
        "endPosition": 50,
        "delay": 100
      },
      {
        "delay": 200,
        "drawFull": true,
        "drawToPosition": 100,
        "drawFromPosition": 0,
        "name": "PrimaryBottom",
        "startPosition": 94.4
      },
      {
        "drawFromPosition": 50,
        "drawFull": true,
        "name": "EquatorRight",
        "startPosition": 50,
        "delay": 0,
        "drawToPosition": 100
      },
      {
        "endPosition": 50,
        "drawFromPosition": 50,
        "startPosition": 27.5,
        "removeAtEndPosition": true,
        "drawFull": true,
        "drawToPosition": 100,
        "name": "RightTopAux"
      }
    ],
    "delayVertical": false
  }
]